import { useMutationApi } from './global/useApi';

/**
 * Updates user to set slack token
 */
export function useSetSlackToken() {
  return useMutationApi('/users/set-slack-token/', {}, { method: 'PATCH' });
}
